import React, { Component } from "react";
import Stepper from "../../../../../../Component/Stepper";
// import Details from './details';
import Define from "./define";
import Details from "./details";

const POST_DATA = {
  exitpolicyid: null,
  policyname: null,
  description: null,
  noticeperioddays: 30,
  isselfresignallowed: true,
  ismanagerresignallowed: false,
  isselfnoticechangeallowed: false,
  ismanagernoticechangeallowed: false,
};

export default class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: POST_DATA,
      activeStep: 1,
      AllStep: [],
      completed: false,
    };
    this.updatePostData = this.updatePostData.bind(this);
    this.setStep = this.setStep.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.updateSteps = this.updateSteps.bind(this);
  }

  componentDidMount() {
    let DATA;
    if (this.props.onCreate) {
      DATA = { ...POST_DATA };
    } else {
      DATA = { ...this.props.editData };
    }
    this.setState({ postData: DATA }, () => this.updateSteps());
  }

  componentWillUnmount() {
    console.log("in componentWillUnmount");
  }

  updateSteps() {
    const { postData } = this.state;
    const { currentEditData } = this.props;
    const AllStep = [
      {
        component: (
          <Define
            onRef={(ref) =>
              this.setState({
                child0: {
                  ...ref,
                  onCancel: this.onCancel,
                },
              })
            }
            {...this.props}
            postData={postData}
            currentEditData={currentEditData}
            onNextClick={this.onNextClick}
            updatePostData={this.updatePostData}
            setStep={this.setStep}
          />
        ),
        iserror: false,
        label: "Define",
        step: 1,
      },
      {
        component: (
          <Details
            onRef={(ref) =>
              this.setState({
                child1: {
                  ...ref,
                  onCancel: this.onCancel,
                  onPrev: this.onPrevClick,
                },
              })
            }
            {...this.props}
            postData={postData}
            onNextClick={this.onNextClick}
            updatePostData={this.updatePostData}
            setStep={this.setStep}
          />
        ),
        iserror: false,
        label: "Details",
        step: 2,
      },
    ];
    this.setState({ AllStep });
  }

  onCancel = () => {
    this.props.history.push(`${this.props.match.path}`);
  };

  updatePostData(data) {
    this.setState({ postData: data }, () => this.updateSteps());
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  onNextClick = () => {
    if (this.child) {
      this.child.handleNext();
    }
  };

  onPrevClick = () => {
    this.child.handleBack();
  };

  render() {
    const { child0, child1 } = this.state;
    return (
      <div style={{ display: "block", width: "100%" }}>
        <Stepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          activeStep={this.state.activeStep}
          setStep={this.setStep}
          completed={this.state.completed}
          childs={[child0, child1]}
        />
      </div>
    );
  }
}

// const POST_DATA = {
//   policyname: "",
//   description: "",
//   noticeperioddays: null,
//   isselfresignallowed: null,
//   ismanagerresignallowed: null,
//   isselfnoticechangeallowed: null,
//   ismanagernoticechangeallowed: null,
//   subscriptionid: null
// };
